import { ProForm } from '@ant-design/pro-components'
import { type ReactNode, useId } from 'react'
import { DateInput, type DateInputProps } from '../components/DateInput'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'

export type DateInputFieldProps = Omit<DateInputProps, 'value' | 'onChange'> & {
  label?: ReactNode
  required?: boolean
}

export function DateInputField(props: DateInputFieldProps) {
  const { label, required, className, ...inputProps } = props
  const fieldCtx = useFieldContext<string | undefined>()
  const editable = useEditableFieldMode<string | undefined>()
  const generatedId = useId()
  const id = inputProps.id ?? generatedId

  const value = fieldCtx.state.value ?? null

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProForm.Item
        label={
          label && (
            <EditableLabel
              mode={editable.mode}
              enterEdit={editable.enterEdit}
              exitRead={editable.exitRead}
              onUndo={editable.undoAndExit}
              canUndo={editable.canUndo}
            >
              {label}
            </EditableLabel>
          )
        }
        htmlFor={id}
        required={required}
      >
        <DateInput
          {...inputProps}
          id={id}
          value={value}
          onChange={next => fieldCtx.handleChange(next ?? undefined)}
          disabled={editable.mode === 'read'}
          allowClear={!required}
        />
      </ProForm.Item>
    </EditableShell>
  )
}
